<div class="cbp-number-request-company-type-form">
  <p class="cbp-number-request-company-type-form__text bold-weight">{{ "LABELS.SELECT_ENTITY_IOR_TYPE" | translate }}</p>

  <div class="cbp-number-request-company-type-form__options">
    <div
      class="card card-step company-type"
      [ngClass]="{
        'is-selected': formGroup?.get('businessType').value === enumCompanyBusinessType.CORPORATION
      }"
    >
      <div class="card-header">
        <app-radio-button
          [id]="'businessType-corporate'"
          classGroup="m-0 flex-grow-1"
          [value]="enumCompanyBusinessType.CORPORATION"
          [name]="'businessType'"
          [control]="formGroup?.get('businessType')"
          [label]="'LABELS.BUSINESS_TYPE_NAME.CORPORATION' | translate | uppercase"
        ></app-radio-button>
      </div>
    </div>

    <div
      class="card card-step company-type"
      [ngClass]="{
        'is-selected': formGroup?.get('businessType').value === enumCompanyBusinessType.SOLE_PROPRIETOR
      }"
    >
      <div class="card-header">
        <app-radio-button
          [id]="'businessType-non-corporate'"
          classGroup="m-0 flex-grow-1"
          [value]="enumCompanyBusinessType.SOLE_PROPRIETOR"
          [name]="'businessType'"
          [control]="formGroup?.get('businessType')"
          [label]="'LABELS.BUSINESS_TYPE_NAME.SOLE_PROPRIETOR' | translate | uppercase"
        ></app-radio-button>
      </div>
    </div>

    <div
      class="card card-step company-type"
      [ngClass]="{
        'is-selected': formGroup?.get('businessType').value === enumCompanyBusinessType.INDIVIDUAL
      }"
    >
      <div class="card-header">
        <app-radio-button
          [id]="'businessType-individual'"
          classGroup="m-0 flex-grow-1"
          [value]="enumCompanyBusinessType.INDIVIDUAL"
          [name]="'businessType'"
          [control]="formGroup?.get('businessType')"
          [label]="'LABELS.BUSINESS_TYPE_NAME.INDIVIDUAL' | translate | uppercase"
        ></app-radio-button>
      </div>
    </div>
  </div>
</div>
